export const CUSTOM_TONE_VALUE = '__custom__';

// Each preset's `value` is the exact string persisted in AiAgent#tone and used
// verbatim by Kraftchat::Ai::PromptBuilder - keep these in sync if the wording
// ever changes, since existing agents rely on matching this exact string to
// re-select their preset instead of falling back to "Personalizado".
export const TONE_PRESETS = [
  {
    value: 'profissional, claro e acolhedor',
    label: 'Profissional e acolhedor',
  },
  { value: 'objetivo, direto e conciso', label: 'Objetivo e direto' },
  {
    value: 'amigável, próximo e informal, mantendo clareza e respeito',
    label: 'Amigável e informal',
  },
  {
    value:
      'consultivo, explicativo e orientado a ajudar o cliente a tomar decisões',
    label: 'Consultivo',
  },
  {
    value: 'persuasivo, cordial e orientado à conversão, sem ser insistente',
    label: 'Comercial',
  },
  { value: 'formal, técnico e respeitoso', label: 'Formal' },
];

// Returns the matching preset value for an exact-text match, or the
// "Personalizado" sentinel otherwise - never mutates or overwrites the
// existing tone text, only decides which UI state to show it in.
export const resolveTonePresetValue = tone => {
  const preset = TONE_PRESETS.find(item => item.value === tone);
  return preset ? preset.value : CUSTOM_TONE_VALUE;
};

// New agents created from the UI default to this pair - the DB column
// defaults stay conservative (tts-1/neutral) for backward compatibility with
// every already-existing agent, which never goes through this default.
export const NEW_AGENT_SPEECH_MODEL = 'automatic';
export const NEW_AGENT_SPEECH_PROFILE = 'pt_br_neutral';

// `value` is the provider-agnostic identifier persisted on AiAgent and
// resolved server-side (Kraftchat::Ai::Speech::Providers::OpenAi::MODELS) -
// only OpenAI is wired up today, but the identifiers themselves don't name it.
// The backend is the sole authority on what "automatic" resolves to; the hint
// text below is purely informational copy, not a second resolution path.
export const SPEECH_MODEL_OPTIONS = [
  { value: 'automatic', label: 'Automático — recomendado' },
  { value: 'gpt-4o-mini-tts', label: 'GPT-4o Mini TTS' },
  { value: 'tts-1', label: 'TTS-1 (clássico)' },
];

export const AUTOMATIC_MODEL_HINT = 'Hoje resolve para gpt-4o-mini-tts.';

// Models that ignore `instructions` server-side (Speech::Providers::OpenAi
// normalizes this by never sending instructions to them) - mirrored here only
// to steer the UI, the backend enforces the real behavior independently.
export const SPEECH_MODELS_WITHOUT_PROFILE_SUPPORT = ['tts-1'];

export const SPEECH_PROFILE_OPTIONS = [
  { value: 'neutral', label: 'Neutro' },
  { value: 'pt_br_neutral', label: 'Português brasileiro neutro' },
];
